import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { h6Styles, pStyles } from 'utils/resuable-css';

export const AllIssueSC = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  margin: 1.5em 0;
`;

export const TopHeadingContainer = styled.div`
  padding-bottom: 1em;
`;

export const HeadingCon = styled.div`
  margin-bottom: 5px;
`;

export const Heading = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  margin: 0;
  font-weight: normal;
  span {
    font-weight: bold;
    text-transform: capitalize;
  }
`;

export const MarkdownHeading = styled.div`
  display: flex;
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
  .key {
    font-weight: bold;
    text-transform: capitalize;
    font-size: ${(props) => props.theme.default?.h6};
    ${(props) => h6Styles(props.theme.resolutions)};
    margin-right: 5px;
  }
`;

export const SecondRow = styled.div`
  margin-top: 1.3em;
`;

export const Flex = styled.div`
  display: flex;
  p {
    margin: 0;
  }
  .dot {
    font-size: 5px;
    margin: 0 8px;
    color: #606c7c;
  }
`;

export const Chat = styled.div`
  margin: 2em 0;
`;

export const ReplyChatContainerBg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  padding: 20px;
  border-radius: 5px;
  margin-left: 72px;
  background: ${(props) => props.theme.lightShadeBackgroundColor};
  @media only screen and (max-width: 900px) {
    margin-left: 43px;
  }
`;

export const ReplyChatContainer = styled.div`
  margin-top: 2em;
  width: 100%;
  margin-left: 72px;
  @media only screen and (max-width: 900px) {
    margin-left: 43px;
  }
  p {
    font-weight: normal;
  }

  textarea {
    font-size: ${(props) => props.theme.default?.h6};
    ${(props) => h6Styles(props.theme.resolutions)};
    width: 100%;
    border: 2px solid lightgray;
    border-radius: 5px;
    resize: none;
    padding: 10px;
  }
`;

export const Chatlog = styled.div`
  display: flex;
  @media only screen and (max-width: 900px) {
    flex-wrap: wrap !important;
  }
`;

export const ChatMobile = styled.div`
  display: flex;
`;

export const Div1 = styled.div`
  width: 22em;
`;

export const WidthDiv = styled.div`
  width: 22em;
  @media only screen and (max-width: 900px) {
    display: none !important;
  }
`;

export const Div3 = styled.div`
  width: 100%;
`;

export const DateSC = styled.div`
  background: ${(props) => (props.bg ? props.theme.lightShadeBackgroundColor : '#606c7c')};
  padding: ${(props) => (props.bg && props.vip ? '20px 5px' : '20px')};
  color: ${(props) => (props.bg ? 'black' : 'white')};
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  .firstLink {
    display: flex;
    margin-right: 5px;
    .crown {
      font-size: 18px;
      color: ${(props) => props.theme.primaryDarkColor};
    }
    .dollar {
      color: green;
      font-size: 18px;
    }
  }
  @media only screen and (min-width: 900px) {
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid ${(props) => (props.bg ? props.theme.lightShadeBackgroundColor : '#606c7c')};
      position: absolute;
      top: 20px;
      right: -9px;
    }
  }
  @media only screen and (max-width: 900px) {
    margin-left: 35px;
    &:before {
      content: '';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid ${(props) => (props.bg ? props.theme.lightShadeBackgroundColor : '#606c7c')};
      position: absolute;
      top: 20px;
      left: -10px;
    }
  }
`;

export const Date = styled.div`
  font-weight: normal;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
  .onlyUser {
    margin: 0;
    margin-bottom: 4px;
  }
`;

export const UserNameContainer = styled(Link)`
  display: flex;
  margin-bottom: 3px;
  .user {
    margin: 0;
    margin-right: 5px;
    color: black;
  }
  .username {
    text-decoration: underline;
    margin: 0;
  }
  .circle {
    margin-left: 2px;
    margin-top: 2px;
  }
`;

export const ClientHeight = styled.div`
  height: 8.8em;
`;

export const Line = styled.div`
  position: relative;
  margin: 0 35px;
  width: 2px !important;
  min-height: 100%;
  background: #bfbfbf;
  color: #ff7300;
  i {
    position: absolute;
    font-size: 18px;
    top: 21px;
    // top: ${(props) => (props.bg ? '8em' : '21px')};
    right: -13px;
  }
  @media only screen and (max-width: 900px) {
    margin: 0;
    margin-left: 8px;
  }
`;
export const IPSC = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  color: ${(props) => (props.bg ? 'gray' : 'white')};
  .dot {
    font-size: 5px;
    margin: 0 8px;
    margin-top: -12px;
  }
  .ip {
    margin: 0;
  }
`;

export const DetailSC = styled.div`
  background: ${(props) => (props.bg ? props.theme.lightShadeBackgroundColor : '#606c7c')};
  color: ${(props) => (props.bg ? 'black' : 'white')};
  padding: 20px;
  margin-bottom: ${(props) => (props.secret ? '10px' : '30px')};
  border-radius: 5px;
  position: relative;
  p {
    font-size: ${(props) => props.theme.default?.p};
    ${(props) => pStyles(props.theme.resolutions)};
    font-weight: normal;
  }
  a {
    color: ${(props) => (props.bg ? '#4183c4' : '#99FFFF')};
    text-decoration: underline;
  }
  &:before {
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid ${(props) => (props.bg ? props.theme.lightShadeBackgroundColor : '#606c7c')};
    position: absolute;
    top: 20px;
    left: -10px;
  }
  @media only screen and (max-width: 900px) {
    margin-left: 35px;
  }
`;

export const ReplyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: 3em;
  padding: 0 10px;
  div {
    width: 28em;
  }
  p {
    margin: 0;
    margin-bottom: 5px;
  }
`;

export const ReplyChat = styled.p`
  color: #606c7c;
  border: 1px solid lightgray;
  border-radius: 20px;
  padding: 5px 10px;
  font-weight: bold;
  margin-right: 3px;
`;

export const Button = styled.div`
  pointer-events: ${({ loading, pointerEvents }) => (pointerEvents?.pointerEvents ? 'none' : loading ? 'none' : '')};
  button {
    position: relative;
    text-transform: uppercase;
    opacity: ${({ loading, pointerEvents }) => (pointerEvents?.pointerEvents ? 0.7 : loading ? 0.7 : 1)};
    color: white;
    opacity: ${({ loading }) => (loading ? 0.3 : 1)};
    border: 0;
    padding: 0.5rem 1.4rem;
    font-size: 14px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    background-color: green;
    margin-top: 10px;
    margin-right: 10px;
    :disabled {
      opacity: 0.3;
      background-color: gray;
    }
    p {
      margin: 0;
      text-decoration: underline;
    }
    span {
      margin: 0 8px;
    }
    i {
      margin-top: 2px;
      margin-left: 12px;
    }
  }
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const SecretContainer = styled.div`
  display: flex;
  max-width: 800px;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 20px;
  @media only screen and (max-width: 700px) {
    display: block;
  }
`;

export const WysimarkInfo = styled.div`
  width: 45%;
  font-weight: 500;
  margin-right: 20px;
  @media only screen and (max-width: 700px) {
    width: 100%;
  }
`;

export const SecrectInputContainer = styled.div`
  width: 300px;
  @media only screen and (max-width: 700px) {
    width: 100%;
`;
